import React from "react";
import "./card.less";
import { useSelector } from "react-redux";

export interface CardInterface {
   extra?: React.ReactNode[] | React.ReactNode;
   cover?: React.ReactNode;
   title?: React.ReactNode[] | React.ReactNode;
   avatar?: React.ReactNode;
   description?: React.ReactNode;
   children: React.ReactNode;
   actions?: React.ReactNode[];
   className?: string;
   overflow?: string;
   id?: string;
   key?: string | number;
   style?: React.CSSProperties;
   hideCardHead?: boolean;
   onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
   cardType?: string;
}

export const Card: React.FC<CardInterface> = ({
   extra,
   cover,
   title,
   avatar,
   description,
   children,
   actions,
   className = "",
   overflow = "clip",
   id,
   key,
   style,
   hideCardHead = false,
   onClick,
   cardType,
}) => {
   const { areWidgetSettingsVisible } = useSelector((state: any) => state.settings);
   return (
      <div
         className={"bp2-card-component " + className}
         id={id}
         key={key}
         style={style}
         onClick={onClick}
      >
         {hideCardHead === false && cardType !== "widget" ? (
            <div className="card-head">
               {cover && <div className="card-cover">{cover}</div>}
               {extra && <div className="card-extra">{extra}</div>}

               <div className="card-meta">
                  {avatar && <div className="card-meta-avatar">{avatar}</div>}
                  {title && <div className="card-meta-title">{title}</div>}
                  {description && <div className="card-meta-description">{description}</div>}
               </div>
            </div>
         ) : null}

         <div className="card-body" style={{ overflow: overflow }}>
            {children}
         </div>
         {areWidgetSettingsVisible && cardType === "widget" && extra && (
            <div className="card-extra">{extra}</div>
         )}

         {actions && (
            <div className="card-actions">
               <ul className="card-actions-list">
                  {actions &&
                     actions.map((item, i) => (
                        <li
                           key={i}
                           className="card-action"
                           style={{ width: 100 / actions.length + "%" }}
                        >
                           {item}
                        </li>
                     ))}
               </ul>
            </div>
         )}
      </div>
   );
};

export default Card;
